import { PopoverWrapper, type PopoverWrapperPropsType } from "./PopoverWrapper"
import { tooltipConfig } from "./tooltipConfig"

export type TooltipWrapperPropsType = Omit<
  PopoverWrapperPropsType,
  "responsive"
>

export function TooltipWrapper({
  content,
  children,
  ...popoverProps
}: TooltipWrapperPropsType) {
  return (
    <PopoverWrapper
      {...tooltipConfig}
      {...popoverProps}
      content={content}
      responsive={false}
    >
      {children}
    </PopoverWrapper>
  )
}
